import { render } from "./Checkbox.vue?vue&type=template&id=3c85073e&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=3c85073e&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c85073e"

export default script